import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
  updateBidsList,
  placeBid,
  findBidData
} from 'src/redux/actions/bidding';
import { sendNotification } from 'src/redux/actions/notifications';
import {
  getLocale,
  getAllPexunit,
  getAllPexunitIds,
  getUser,
  getTimeStamp,
  getBidData
} from 'src/redux/selectors';
import {
  addPexunit,
  deletePexunit,
  findAllPexunit
} from 'src/redux/actions/pexunit';
import {
  addRequest,
  findJobNumbers,
  findTechnicians
} from 'src/redux/actions/pexrequest';
import { withRouter, Link } from 'react-router-dom';

class Pexunit extends Component {
  render = () => {
    const {
      Layout,
      currentLocale,
      pexunit,
      user,
      findAllPexunit,
      addPexunit,
      deletePexunit,
      sendNotification,
      findJobNumbers,
      findTechnicians,
      addRequest,
      push,
      history
    } = this.props;
    return (
      <Layout
        currentLocale={currentLocale}
        pexunit={pexunit}
        user={user}
        findAllPexunit={findAllPexunit}
        addPexunit={addPexunit}
        deletePexunit={deletePexunit}
        sendNotification={sendNotification}
        findJobNumbers={findJobNumbers}
        findTechnicians={findTechnicians}
        addRequest={addRequest}
        push={push}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  currentLocale: getLocale(state) || {},
  pexunit: state.pexunit.allPexunit || [],
  user: getUser(state) || {}
});

const mapDispatchToProps = {
  getLocale,
  findAllPexunit,
  addPexunit,
  deletePexunit,
  sendNotification,
  push,
  findJobNumbers,
  findTechnicians,
  addRequest
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Pexunit)
);
